import { useEffect } from 'react';
import { useParams } from 'react-router';
import { Form, Input, Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import InputForm from 'components/InputForm/InputForm';
import SubmitButton from 'components/buttons/SubmitButton/SubmitButton';
import LinkButton from 'components/buttons/LinkButton/LinkButton';
import { getText } from 'utils/stringUtil';
import {
  YOUR_ACCOUNT_EMAIL_ADDRESS,
  INVALID_EMAIL_FORMAT,
  PLEASE_ENTER_YOUR_EMAIL,
  REQUEST_NEW_PASSWORD,
  CANCEL,
} from 'constants/languageConstants';
import {
  requestPasswordReset,
  setEmployeeModal,
} from 'modules/auth/slices/employeeAuthSlice';

import styles from './requestResetPassword.module.less';

const RequestResetPassword = () => {
  const { hash = '', employerName = '' } = useParams();
  const baseUrl = `/${hash}/`;
  const inProgress = useAppSelector((state) => state.employeeAuth.inProgress);
  const language = useAppSelector((state) => state.benguide.data?.language);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const resetPasswordHandler = async (values: any) => {
    const constructRedirectURL = `${window.location.origin}${baseUrl}${employerName}`;
    const response = await dispatch(
      requestPasswordReset(values?.email?.trim(), constructRedirectURL)
    );
    if (response) {
      form?.resetFields();
    }
    return response;
  };

  useEffect(() => {
    return () => {
      form?.resetFields();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Row justify="center" className={styles.wrapperContainer}>
      <InputForm form={form} layout="vertical" onFinish={resetPasswordHandler}>
        <Form.Item
          name="email"
          label={<>{getText(YOUR_ACCOUNT_EMAIL_ADDRESS, language)}</>}
          rules={[
            {
              type: 'email',
              message: getText(INVALID_EMAIL_FORMAT, language),
            },
            {
              required: true,
              message: getText(PLEASE_ENTER_YOUR_EMAIL, language),
            },
          ]}
        >
          <Input className={styles.inputWrapper} name="email" autoFocus />
        </Form.Item>

        <SubmitButton
          type="primary"
          htmlType="submit"
          disabled={inProgress}
          loading={inProgress}
          className={styles.submitPwdButton}
        >
          {getText(REQUEST_NEW_PASSWORD, language)}
        </SubmitButton>

        <Row justify="center">
          <LinkButton
            className={styles.resetPwdButton}
            onClick={() => dispatch(setEmployeeModal(false))}
          >
            {getText(CANCEL, language)}
          </LinkButton>
        </Row>
      </InputForm>
    </Row>
  );
};

export default RequestResetPassword;
